<template>
  <div class="company-contact-wrapper">
    <ul
      id="company-contact-accordion"
      class="accordion accordion-customize"
      data-accordion
      data-deep-link="true"
      data-allow-all-closed="true"
      data-multi-expand="true"
      data-update-history="true"
      data-deep-link-smudge="500"
    >
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title"><span>{{ $t('company.titles.contact') }}</span></a>
        <div
          class="accordion-content"
          data-tab-content
        >
          <table>
            <thead>
              <tr>
                <th>{{ $t('company.contactTable.name') }}</th>
                <th>{{ $t('company.contactTable.title') }}</th>
                <th>{{ $t('company.contactTable.department') }}</th>
                <th>{{ $t('company.contactTable.propPeople') }}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in ccdcontacts"
                :key="`company_contact_${index}`"
              >
                <td>
                  <a
                    class="link"
                    @click="navTo('ccdContactView', { id: item.id })"
                  >
                    {{ displayI18nFullName(item.firstName, item.lastName) || item.name }}
                  </a>
                </td>
                <td>
                  <input
                    v-if="allowEdit"
                    v-hkldinput
                    type="text"
                    :value="deep(item, 'CompanyContact.title')"
                    @change="event => updatePathField(item.id, 'title', event.target.value)"
                  >
                  <div v-if="!allowEdit">
                    {{ deep(item, 'CompanyContact.title') }}
                  </div>
                </td>
                <td>
                  <input
                    v-if="allowEdit"
                    v-hkldinput
                    type="text"
                    :value="deep(item, 'CompanyContact.department')"
                    @change="event => updatePathField(item.id, 'department', event.target.value)"
                  >
                  <div v-if="!allowEdit">
                    {{ deep(item, 'CompanyContact.department') }}
                  </div>
                </td>
                <td>
                  <input
                    :id="'checkbox_' + index"
                    v-hkldinput
                    type="checkbox"
                    :disabled="!allowEdit"
                    :checked="deep(item, 'CompanyContact.isPropertyPerson') ? 'checked' : ''"
                    @change="updatePathField(item.id, 'isPropertyPerson', !deep(item, 'CompanyContact.isPropertyPerson'))"
                  >
                </td>
                <td class="icon-remove">
                  <i
                    v-if="allowEdit && !canRemove(item)"
                    class="fa fa-times-thin"
                    @click="removeContact(item.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <button
            class="btn btn--orange"
            @click="navTo('contacts', {}, { companyId: currentCompany.id, from: ccdRouteNames.companyEdit })"
          >
            {{ $t('company.contactTable.linkContact') }}
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import formFullnameMixin from '@/pages/formFullnameMixin'
import mutationTypes from '@/store/mutation-types'
import navigation from '@/utils/navigation'
import { ccdRouteNames } from '@/utils/consts'

export default {
  name: 'CompanyContact',
  mixins: [formFullnameMixin],
  props: {
    allowEdit: Boolean,
  },
  data () {
    return {
      deep,
      ccdRouteNames,
    }
  },
  computed: {
    ...mapGetters('ccd', ['currentCompany']),
    originCcdcontacts () {
      return lodash.get(this.currentCompany, 'ccdcontacts', {})
    },
    ccdcontacts () {
      return lodash.orderBy(this.originCcdcontacts, 'name')
    },
  },
  mounted () {
    if (!this.companyContactAccordion) {
      this.companyContactAccordion = new Foundation.Accordion($('#company-contact-accordion'))
    }
  },

  destroyed () {
    if (this.companyContactAccordion) {
      this.companyContactAccordion.destroy()
    }
  },
  methods: {
    ...mapActions('ccd', [
      'linkContactsToCompany',
    ]),
    ...mapMutations('ccd', {
      updateCompanyContactPathField: mutationTypes.COMPANY_CONTACT_UPDATE_PATH_FIELD,
      removeCompanyContact: mutationTypes.COMPANY_REMOVE_CONTACT,
    }),
    updatePathField (id, path, value) {
      this.updateCompanyContactPathField({
        index: this.getIndexNeedChange(id),
        path: [path],
        newValue: value,
      })
    },
    navTo (name, params, query) {
      navigation.toPage(name, params, query)
    },
    getIndexNeedChange (id) {
      let indexNeedChange
      this.originCcdcontacts.map((item, index) => {
        if (item.id === id) {
          indexNeedChange = index
        }
      })
      return indexNeedChange
    },
    removeContact (id) {
      this.removeCompanyContact({ index: this.getIndexNeedChange(id) })
    },
    canRemove (item) {
      let disableRemove = false
      if (item.CompanyContact.tenancyId) {
        disableRemove = true
      }
      return disableRemove
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/view';
@import '~styles/accordion';
@import '~styles/table';
@import '~styles/icon_remove';

table td input[type="text"] {
  height: 40px;
}
.icon-remove {
  display: inline-block;
  width: 20px;
  text-align: center;
  line-height: 40px;
  cursor: hand;
  color:#888;
  span {
    cursor: pointer;
  }
}

input[type="checkbox"]:disabled {
  opacity: 0.6;
}
.link {
  text-decoration: underline;
  color: #0C3A58;
}
</style>
